<script>
  export let label;
  export let to;
  export let type = '';
  export let fontSize = '';
  export let targetSelf = false;
  export let ripple = '';
</script>

{#if targetSelf}
  <a class="{type} {ripple} {fontSize}" href={to} target="_self">{label}</a>
{:else}
  <a class="{type} {ripple} {fontSize}" href={to}>{label}</a>
{/if}

<style>
  a {
    display: inline-block;
    padding: 1.2rem 3rem;
    font-family: 'Oswald', sans-serif;
    font-weight: 500;
    border: none;
    font-size: 1.5rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    cursor: pointer;
    border: 2px solid transparent;
    background-color: #fff;
    border: 2px solid #fff;
    transition: background-color 0.2s ease;
    text-align: center;
  }
  a {
    color: #000;
    text-decoration: none;
  }

  a:hover {
    background-color: transparent;
  }

  a:hover {
    color: #fff;
  }

  a.large {
    font-size: 2.2rem;
  }

  a.extra-large {
    font-size: 3.4rem;
  }

  .orange {
    background-color: #fe5900;
    border: 2px solid #fe5900;
  }

  .orange:hover {
    background-color: transparent;
  }

  .orange:hover {
    color: #fe5900;
  }

  .orange {
    color: #fff;
  }

  .orange-o {
    border: 2px solid #fe5900;
    background-color: transparent;
  }

  .orange-o:hover {
    background-color: #fe5900;
  }

  .orange-o:hover {
    color: #fff;
  }

  .orange-o {
    color: #1c2a5c;
  }

  .navy {
    background-color: #1c2a5c;
    border: 2px solid #1c2a5c;
  }

  .navy:hover {
    background-color: transparent;
  }

  .navy {
    color: #fff;
  }

  .black-o {
    background-color: transparent;
    border: 2px solid #000;
  }

  .black-o:hover {
    background-color: #000;
    border: 2px solid #000;
  }

  .black-o:hover {
    color: #fff;
  }

  .black-o {
    color: #000;
  }

  .black {
    background-color: #000;
    border: 2px solid #000;
  }

  .black:hover {
    background-color: transparent;
  }

  .black {
    color: #fff;
  }

  .black:hover {
    color: #000;
  }

  .large {
    font-size: 2.2rem;
  }

  .ripple {
    display: block;
    border-radius: 5%;
    border: 2px red solid;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% {
      -webkit-box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.4);
    }
    70% {
      -webkit-box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
    }
    100% {
      -webkit-box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
    }
  }
</style>
